import type { RouteRecordRaw } from 'vue-router'
import { Role } from '../../Constants/Role.ts'
import { Routes } from '../../Constants/Routes.ts'
import ContractRestructuringDocumentsTab from '../../Views/Restructuring/ContractRestructuringDocumentsTab.vue'
import { assertThat } from '../Guards'
import ContractRestructuringListPage from '../../Views/Restructuring/ContractRestructuringListPage.vue'
import ContractRestructuringViewPage from '../../Views/Restructuring/ContractRestructuringViewPage.vue'
import ContractRestructuringFormPage from '../../Views/Restructuring/ContractRestructuringFormPage.vue'
import ContractRestructuringInformationTab from '../../Views/Restructuring/ContractRestructuringInformationTab.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/restructuration',
    meta: {
      guards: assertThat().authenticated().hasRole(Role.RESTRUCTURING),
    },
    children: [
      {
        name: Routes.RESTRUCTURING_LIST,
        path: '',
        component: ContractRestructuringListPage,
      },
      {
        name: Routes.RESTRUCTURING_CREATE,
        path: 'create',
        component: ContractRestructuringFormPage,
      },
      {
        name: Routes.RESTRUCTURING_VIEW,
        path: ':id(\\d+)',
        component: ContractRestructuringViewPage,
        props: (route) => ({ id: Number(route.params.id) }),
        children: [
          {
            name: Routes.RESTRUCTURING_VIEW_INFORMATION,
            path: '',
            component: ContractRestructuringInformationTab,
          },
          {
            name: Routes.RESTRUCTURING_VIEW_DOCUMENTS,
            path: 'documents',
            component: ContractRestructuringDocumentsTab,
          },
        ],
      },
      {
        name: Routes.RESTRUCTURING_EDIT,
        path: ':id(\\d+)/edit',
        component: ContractRestructuringFormPage,
        props: (route) => ({
          id: Number(route.params.id),
        }),
        meta: {
          step: 'outstanding_repurchase',
        },
      },
    ],
  },
]

export default routes
